import { userSession } from '@/api/modules/login.api.js';
import Config from '@/services/config.service';
import appAPI from '@/api/modules/app.api.js';
const appConfig = new Config();
export default [
  {
    path: 'accounts/users',
    name: 'Users',
    component: () => import('./views/Users.vue'),
    beforeEnter: async (to, from, next) => {
      
      if (!userSession.isSuperuser() && appConfig.isSaas) {
        return next({
          name: '403Page',
          params: {
            locale: to.params.locale,
          },
        });
      }
      return next();
    },
  },
  {
    path: 'accounts/users/new',
    name: 'AddUser',
    component: () => import('./views/AddUser.vue'),
  },
  {
    path: 'accounts/users/:id',
    name: 'UserDetail',
    component: () => import('./views/UserDetail.vue'),
    beforeEnter: async (to, from, next) => {
      
      if (!userSession.isSuperuser() && appConfig.isSaas) {
        return next({
          name: '403Page',
          params: {
            locale: to.params.locale,
          },
        });
      }
      return next();
    },
  }
];